export default __webpack_public_path__ + "4ca833df84d05c8fa413fd9571755c70.png";